
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import globalThis_1 from './global-this.js';
import functionApply from './function-apply.js';
import isCallable$1 from './is-callable.js';
import environment from './environment.js';
import environmentUserAgent from './environment-user-agent.js';
import arraySlice$1 from './array-slice.js';
import validateArgumentsLength$1 from './validate-arguments-length.js';

var globalThis = globalThis_1;
var apply = functionApply;
var isCallable = isCallable$1;
var ENVIRONMENT = environment;
var USER_AGENT = environmentUserAgent;
var arraySlice = arraySlice$1;
var validateArgumentsLength = validateArgumentsLength$1;

var Function = globalThis.Function;
// dirty IE9- and Bun 0.3.0- checks
var WRAP = /MSIE .\./.test(USER_AGENT) || ENVIRONMENT === 'BUN' && (function () {
  var version = globalThis.Bun.version.split('.');
  return version.length < 3 || version[0] === '0' && (version[1] < 3 || version[1] === '3' && version[2] === '0');
})();

// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
var schedulersFix = function (scheduler, hasTimeArg) {
  var firstParamIndex = hasTimeArg ? 2 : 1;
  return WRAP ? function (handler, timeout /* , ...arguments */) {
    var boundArgs = validateArgumentsLength(arguments.length, 1) > firstParamIndex;
    var fn = isCallable(handler) ? handler : Function(handler);
    var params = boundArgs ? arraySlice(arguments, firstParamIndex) : [];
    var callback = boundArgs ? function () {
      apply(fn, this, params);
    } : fn;
    return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
  } : scheduler;
};

export { schedulersFix as default };
//# sourceMappingURL=schedulers-fix.js.map
